import { Grid, Group, Paper, Space, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router"
import { DateRangeChip } from "../../components/list"
import { useFilterState } from "../../hooks/useFilterState"
import { dateTimeFormat } from "../../utils/date"
import { renderBusinessName } from "../../utils/render-business-name"
import { SalesInvoicesList } from "./sales-invoices-list"

export const ClosedInvoice = ({ data }: { data: any }) => {
  const params = useParams()
  const { t } = useTranslation("invoice")
  const { filters, mergeFilters } = useFilterState<{ businessId: string; type: string; startDate: string | null; endDate: string | null }>({
    businessId: `${params.id}`,
    type: "CLOSED",
    startDate: null,
    endDate: null,
  })

  return (
    <>
      <Paper my={"xs"}>
        <Group align="apart">
          <Text fw={700} fz={"xl"}>
            {t("buyerName")}{" "}
            <Text c="gray.9" component="span">
              {renderBusinessName(data?.receiverBusiness)}
            </Text>
            <Text c="gray.9"># {data?.receiverBusiness?.refCode || "-"}</Text>
          </Text>

          <Text component="span" ta="end" fz={"sm"} fw={500}>
            <Text>{t("ourBuyer.dateTime")}</Text>
            <Text>{dateTimeFormat(data.createdAt)} </Text>
            <Text> (Current)</Text>
          </Text>
        </Group>
        <Space h={"lg"} />
        <Grid>
          <Grid.Col>
            <Paper withBorder p={"lg"}>
              <Text c="gray" fw={500} mb={"xs"}>
                {t("ourBuyer.historyTitle")}
              </Text>
              <DateRangeChip
                label={t("ourBuyer.dateRangeLabel")}
                value={[filters.startDate, filters.endDate]}
                onChange={([startDate, endDate]) => mergeFilters({ startDate, endDate })}
              />
            </Paper>
          </Grid.Col>
          <Grid.Col>
            <SalesInvoicesList title={t("closedInvoice")} filters={filters} />
          </Grid.Col>
        </Grid>
      </Paper>
    </>
  )
}
